export enum AsyncActionStatus {
    EMPTY = 'EMPTY',
    QUEUED = 'QUEUED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    FAILED = 'FAILED',
}

export interface IAsyncAction<T> {
    status: AsyncActionStatus;
    result: T;
    params?: unknown;
}
